import { render, staticRenderFns } from "./demandStatistics.vue?vue&type=template&id=6bbc4b39"
import script from "./demandStatistics.vue?vue&type=script&lang=js"
export * from "./demandStatistics.vue?vue&type=script&lang=js"
import style0 from "./demandStatistics.vue?vue&type=style&index=0&id=6bbc4b39&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports